module.exports = __webpack_public_path__ + "img/scan (6).1ebddb9b.png";